import type {
  CampaignGroupsQueryResponse,
  CampaignGroupsQueryVariables,
} from '~/api/graphql/queries/campaignGroups.generated';
import type { UseInfiniteQueryOptions } from '@tanstack/react-query';

import { CampaignGroupsDocument } from '~/api/graphql/queries/campaignGroups.generated';
import { useInfiniteQuery } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils';

const INFINITE_KEY = 'campaign-groups-infinite';

export const useInfiniteCampaignGroups = <TError = unknown>(
  variables: CampaignGroupsQueryVariables,
  options?: Omit<
    UseInfiniteQueryOptions<CampaignGroupsQueryResponse, TError, CampaignGroupsQueryResponse>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useInfiniteQuery<CampaignGroupsQueryResponse, TError>(
    [INFINITE_KEY, variables],
    (args) =>
      appFetcher<CampaignGroupsQueryResponse, CampaignGroupsQueryVariables>(
        CampaignGroupsDocument,
        {
          ...variables,
          after: args.pageParam ?? null,
        },
      )(),
    options,
  );
};
useInfiniteCampaignGroups.getKey = (variables: CampaignGroupsQueryVariables) => [
  INFINITE_KEY,
  variables,
];
